module.exports = __webpack_public_path__ + "home_value_v2.0c3757b398606c87c67b.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/home_value_v2.jpg
// module id = ../../../../../src/assets/img/home_value_v2.jpg
// module chunks = styles